import React, { Component } from "react";
import SideNavBar from "./components/sideNavBar";
import firebase from "./firebase";
import LoginPage from "./components/Login/login";
import { setLogInDetails, setAdminRecord } from "./actions/setpersondetailsaction";
import { fetchAdminRecord, storeAdminSession, clearAdminSession } from "./utils/adminAuth";

import { connect } from "react-redux";

class App extends Component {
  constructor() {
    super();
    this.state = { user: null };
    this.authListener = this.authListener.bind(this);
  }

  componentDidMount() {
    this.authListener();
  }

  authListener() {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        // Re-fetch admin record so role is always fresh (handles page refresh)
        const adminRecord = await fetchAdminRecord(user.uid, user.email);

        if (!adminRecord || adminRecord.status !== "active") {
          // Not an admin or suspended – force logout
          await firebase.auth().signOut();
          clearAdminSession();
          this.setState({ user: null });
          this.props.setOnLogInDetails({ isLoggedIn: false });
          return;
        }

        storeAdminSession(adminRecord);
        this.props.setAdminRecord(adminRecord);
        this.setState({ user });
        this.props.setOnLogInDetails({ isLoggedIn: true });
      } else {
        clearAdminSession();
        this.props.setAdminRecord(null);
        this.setState({ user: null });
        this.props.setOnLogInDetails({ isLoggedIn: false });
      }
    });
  }

  render() {
    return (
      <div className="App">
        {this.props.loginDetails.isLoggedIn ? <SideNavBar /> : <LoginPage />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loginDetails: state.loginDetails,
});

const mapDispatchToProps = (dispatch) => ({
  setOnLogInDetails: (p) => dispatch(setLogInDetails(p)),
  setAdminRecord: (record) => dispatch(setAdminRecord(record)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);

